import { handleActions } from 'redux-actions';
import reducersUtils from 'state/utils';
import { removeDuplicates } from 'utils/array';

import actions from 'state/mrCollection/extras/actionCreators';

import initialState from 'state/mrCollection/extras/initial.state';

const extras = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.setExtra]: (state, { payload: { extra } }) => {
      return reducersUtils.reduceExtrasWithExcluyents(extra, state);
    },
    [actions.setExtras]: (state, { payload: { extrasValues } }) => [
      ...removeDuplicates([...extrasValues]),
    ],
  },
  initialState
);

export default extras;
